/// <amd-module name="Feed/Core/Redux/Navigation/NavigationSelectors" />
import { IFeedNavigationAwareState, IHubState } from "./NavigationContracts";

export function getHubState(state: IFeedNavigationAwareState): IHubState {
    return state.navigation.hubState;
}

export function getHubAction(state: IFeedNavigationAwareState): string {
    return state.navigation.hubState.action;
}
